<template>
    <div class="all-bg" v-if="open">
        <div class="custom-modal" v-if="open">
            <div class="video-box">
                <video  ref="video" :src="videoInfo.learnAddress" :poster="videoInfo.thumbnailId?'resrun-paas/file/downloadFileStream/'+videoInfo.thumbnailId:''" 
                controls controlslist="nodownload" width="100%" height="100%" @play="defaultPlay"></video>
            </div>
            <img class="main-paly-btn" src="../../../assets/images/main-play.png" v-if="isPlay" alt="" @click="handlePlay">
            <div class="title">
                <p style="line-height: 0.5rem;">{{ videoInfo.learnName }}</p>
                <p style="font-size: 0.12rem; color: #999;">视屏</p>
            </div>
            
        </div>
        <div class="close-modal" @click="closeDialog">
            <i class="el-icon-close"></i>
        </div>
        <div class="switch-video">
            <span @click="switchVideo('pre')">
                <i class="el-icon-arrow-left"></i>
            </span>
            <span @click="switchVideo('next')">
                <i class="el-icon-arrow-right"></i>
            </span>
        </div>
    </div>
        
</template>
<script>
    export default{
        name:"PlayVideoModal",
        data(){
            return{
                open:false,
                videoInfo:{},
                videoList:[],
                isPlay:true,
            }
        },
        mounted(){
            
        },
        methods:{
            showDialog(info,list){
                this.open = true
                this.videoInfo = info;
                this.videoList = list;
            },
            closeDialog(){
                this.open = false;
                this.videoInfo = {};
                this.videoList = [];
                this.isPlay = true;
            },
            handlePlay(){
                let videoDom = this.$refs.video;
                if(videoDom){
                    videoDom.play();
                    this.isPlay = false;
                }
            },
            defaultPlay(){
                this.isPlay = false;
            },
            switchVideo(type){
                var thisPlayIndex = 0;
                for(var i = 0;i<this.videoList.length;i++){
                    if(this.videoList[i].id == this.videoInfo.id){
                        thisPlayIndex = i;
                    }
                }
                if(type == 'next'){
                    // this.videoList.filter(e=>e.id == )
                    if(thisPlayIndex + 1 == this.videoList.length){
                        thisPlayIndex = 0;
                    }else{
                        thisPlayIndex += 1;
                    }
                }else{
                    if(thisPlayIndex == 0){
                        thisPlayIndex = this.videoList.length - 1;
                    }else{
                        thisPlayIndex -= 1;
                    }
                }
                console.log("thisPlayIndex",thisPlayIndex);
                this.videoInfo = this.videoList[thisPlayIndex];
                
            }
        }

    }
</script>
<style lang="less" scoped>
    .all-bg{
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 999;
        top:0;
        left:0;
        background-color: rgba(0,0,0,0.7);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .custom-modal{
        width: 9.75rem;
        height: 6.17rem;
        background-color: #252525;
        .video-box{
            width: 9.51rem;
            height: 5.33rem;
        }
        .title{
            font-family: Source Han Sans CN;
            font-size: 0.16rem;
            font-weight: 600;
            // line-height: .5rem;
            padding-left: .2rem;
            color: #fff;
            text-align: left;
        }
    }
    .close-modal{
        color: #fff;
        font-size: 0.5rem;
        position: fixed;
        right: .15rem;
        top: .1rem;
        cursor: pointer;
        
    }
    .switch-video{
        width: 100%;
        height: 0.58rem;
        position: absolute;
        display: flex;
        justify-content: space-between;
        span{
            display: block;
            width: 0.58rem;
            height: 0.58rem;
            background-color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.3rem;
            cursor: pointer;
        }
        span:hover{
            font-size: 0.35rem;
        }
    }
    .main-paly-btn{
        position: absolute;
        left:50%;
        top:50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
        z-index: 1001;
    }
</style>